























































































































































































































































































































































































































import { Routes } from "@/router/Routes";
import { BreadCrumb } from "@/store/modules/GlobalStore";
import { Component } from "vue-property-decorator";
import InForceBase from "../base/InForceBase";
import { Route } from "vue-router";
import { inForceStore } from "@/store/modules/InForceStore";
import _ from "lodash";
import { Pages } from "@/enums/Pages";

@Component
export default class extends InForceBase {
  page = Pages.LIFE_DETAIL;
  title = "Existing Business Life Details";
  breadCrumbs = [
    new BreadCrumb("Existing Policies", { name: Routes.EXISTING_BUSINESS }),
  ];
  notification = "";
  panel = [0, 1, 2];
  dialog = false;

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: () => void
  ): Promise<void> {
    await inForceStore.select(to.params.id);
    next();
  }
  created(): void {
    this.title = `Existing Business Life Details`;
    if (inForceStore.current.policyNumber !== null) {
      this.breadCrumbs.push(
        new BreadCrumb(`Policy Number - ${inForceStore.current.policyNumber}`)
      );
    }
    const notificationArray = [];
    if (this.state.termEndingIn180Days) {
      notificationArray.push("Term expiring");
    }
    if (this.state.termLevelPeriodExpired) {
      notificationArray.push("Term expired");
    }
    if (this.state.atRiskOfLapsing) {
      notificationArray.push("Risk of Lapsing");
    }
    if (this.state.laspsedLastMonth) {
      notificationArray.push("Lapsed");
    }
    if (this.state.conversionEndingIn180Days) {
      notificationArray.push("Conversion expiring");
    }
    if (this.state.deathClaimLastMonth) {
      notificationArray.push("Death");
    }
    this.notification = _.join(notificationArray, ", ");
  }
}
